import React from "react";

interface Props {
  className?: string;
}

export const boltInfo = {
  width: 1680,
  height: 361,
} as const;

export const BoltIcon: React.FC<Props> = props => (
  <svg
    viewBox={`0 0 ${boltInfo.width} ${boltInfo.height}`}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path d="M0.119629 360.539L0.117188 312.679L888.029 29.576V321.192L1680.12 0.814453V360.539H0.119629Z" />
  </svg>
);
